/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { SharedTrialOfferProps, TrialOffer } from '../TrialOffer';

/**
 * Offers the opportunity to start a Professional trial.
 */
export const ProfessionalTrialOffer = (props: SharedTrialOfferProps) => (
  <TrialOffer
    description="Unleash the power of automation with advanced tools to take your work to the next level. Harness logic with paths, custom integrations through webhooks, and more to help you can automate virtually anything!"
    features={[
      { iconName: 'miscBolt', label: 'Unlimited Zaps' },
      { iconName: 'personGroup', label: 'Unlimited users' },
      { iconName: 'miscFire', label: 'Unlimited premium apps' },
      { iconName: 'miscClock', label: 'Faster update times' },
    ]}
    fullStoryEventName="Viewed Professional Trial Offer"
    title="Try Zapier For Professionals"
    trialType="Professional"
    {...props}
  />
);
